import { WebStorageStateStore } from 'oidc-client-ts';
import type { AuthProviderProps } from 'react-oidc-context';

/**
 * OIDC wiring for Zitadel, copied from spark-board. Values come from the runtime
 * `window.config`, never from build-time env. When `oidcEnabled` is false the app uses the
 * legacy email sign-in and never mounts the OIDC provider.
 *
 * Authorization Code + PKCE for a public SPA client: no secret, and `offline_access` gives a
 * rotating refresh token so `automaticSilentRenew` keeps the session alive. Tokens live in
 * localStorage so a reload stays signed in; the backend checks the ID token on every request.
 */
export const oidcEnabled: boolean = !!window.config.oidcIssuer;

export const oidcConfig: AuthProviderProps = {
  authority: window.config.oidcIssuer,
  client_id: window.config.oidcClientId,
  redirect_uri: window.location.origin + '/auth/callback',
  post_logout_redirect_uri: window.location.origin + '/',
  response_type: 'code',
  scope: 'openid profile email offline_access',
  automaticSilentRenew: true,
  loadUserInfo: true,
  // Skip the check_session iframe (it needs third-party cookies); refresh-token renewal covers it.
  monitorSession: false,
  revokeTokensOnSignout: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // Strip ?code&state from the URL but keep the /auth/callback path, so the AuthCallback route
  // (app.tsx) can go back to the page asked for before the redirect (see RETURN_TO_KEY).
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
